import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { BModal } from 'bootstrap-vue';
import CCheckbox from '@/components/shared/CCheckbox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WarningModal',
  emits: ["accepted", "close"],
  setup(__props, { emit }: { emit: ({
    (event: 'accepted', value: boolean): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



const isModalOpen = ref(true);
const isAccepted = ref(false);

const onAccepted = () => {
    emit('accepted', isAccepted.value);
};

const onClose = () => {
    emit('close');
};

return { __sfc: true,emit, isModalOpen, isAccepted, onAccepted, onClose, BModal, CCheckbox }
}

})